import ErrorBoundary, { type Props as ErrorBoundaryProps } from './ErrorBoundary'

export {
  ErrorBoundary,
  type ErrorBoundaryProps
}

export default ErrorBoundary
